import { Player, PlayerOrNone } from '../../jscaip/Player';
import { KamisadoColor } from './KamisadoColor';
export class KamisadoPiece {
    player;
    color;
    constructor(player, color) {
        this.player = player;
        this.color = color;
    }
    static EMPTY = new KamisadoPiece(PlayerOrNone.NONE, KamisadoColor.ANY);
    static of(player, value) {
        return new KamisadoPiece(player, KamisadoColor.of(value));
    }
    static createPlayerColors(player) {
        return {
            ORANGE: new KamisadoPiece(player, KamisadoColor.ORANGE),
            BLUE: new KamisadoPiece(player, KamisadoColor.BLUE),
            PURPLE: new KamisadoPiece(player, KamisadoColor.PURPLE),
            PINK: new KamisadoPiece(player, KamisadoColor.PINK),
            YELLOW: new KamisadoPiece(player, KamisadoColor.YELLOW),
            RED: new KamisadoPiece(player, KamisadoColor.RED),
            GREEN: new KamisadoPiece(player, KamisadoColor.GREEN),
            BROWN: new KamisadoPiece(player, KamisadoColor.BROWN),
        };
    }
    static ZERO = KamisadoPiece.createPlayerColors(Player.ZERO);
    static ONE = KamisadoPiece.createPlayerColors(Player.ONE);
    equals(piece) {
        return piece.player === this.player && piece.color === this.color;
    }
    isEmpty() {
        return this.player.equals(PlayerOrNone.NONE);
    }
    belongsTo(player) {
        return this.player === player;
    }
}
